unit AccountChangePassword;

interface

uses
  System.SysUtils,
  System.Classes,
  JS,
  Web,
  WEBLib.Graphics,
  WEBLib.Controls,
  WEBLib.Forms,
  WEBLib.Dialogs,
  WebForm.Core,
  Vcl.StdCtrls,
  WEBLib.StdCtrls,
  Vcl.Controls;

type
  TChangePasswordForm = class(TCoreWebForm)
    ExistingPassword: TEdit;
    NewPassword: TEdit;
    ConfirmPassword: TEdit;
    ChangeButton: TButton;
    CancelButton: TButton;
    PasswordMatchLabel: TLabel;
    procedure CancelButtonClick(Sender: TObject);
    procedure ChangeButtonClick(Sender: TObject);
  private
    { Private declarations }
    [async]
    procedure ChangePassword; async;
  public
    { Public declarations }
  protected procedure LoadDFMValues; override; end;

var
  ChangePasswordForm: TChangePasswordForm;

implementation

{$R *.dfm}

uses
  MainDataModule,
  XData.Web.Client;

procedure TChangePasswordForm.CancelButtonClick(Sender: TObject);
begin
  ModalResult := mrCancel;
end;

procedure TChangePasswordForm.ChangeButtonClick(Sender: TObject);
var
  lExisting: string;
begin
  lExisting := ExistingPassword.Text;
  if lExisting.Trim = '' then
  begin
    ExistingPassword.SetFocus;
    DisplayMessage('Please enter your current password');
    Exit;
  end;

  if NewPassword.Text <> ConfirmPassword.Text then
  begin
    PasswordMatchLabel.Caption := 'Passwords do not match';
    PasswordMatchLabel.Visible := True;
    DisplayMessage('Your passwords do not match');
    Exit;
  end
  else
  begin
    PasswordMatchLabel.Caption := 'Passwords match!';
    PasswordMatchLabel.Visible := True;
  end;

  CancelButton.Enabled := False;
  ChangeButton.Enabled := False;

  ChangePassword;

end;

procedure TChangePasswordForm.ChangePassword;
const
  svc = 'ICustomerService.ChangePassword';
var
  lRetval: TXDataClientResponse;
  lExisting, lNew, lResponse, lMsg: string;
  lErrors: TArray<string>;
  I: Integer;
begin

  lExisting := ExistingPassword.Text;
  lNew := NewPassword.Text;

  lRetval := Await(TXDataClientResponse, MainData.WebClient.RawInvokeAsync(svc,
      [lExisting, lNew]));
  lResponse := JS.toString(lRetval.ResultAsObject['value']);

  If lResponse = 'OK' then
  begin
    DisplayMessage('Your password has been updated.');
    ModalResult := mrOK;
  end
  else if lResponse = 'UnidentifiedUser' then
  begin
    DisplayMessage('We were not able to update your password. please try later.', TMsgDlgType.mtError);
    ModalResult := mrCancel;
  end
  else if lResponse = 'ExistingMismatch' then
  begin
    DisplayMessage('Your current password is not correct. Please try again.', TMsgDlgType.mtError);
    ExistingPassword.SetFocus;
    CancelButton.Enabled := True;
    ChangeButton.Enabled := True;
  end
  else if lResponse = 'InternalError' then
  begin
    DisplayMessage('We were not able to update your password. please try later.', TMsgDlgType.mtError);
    ModalResult := mrCancel;
  end
  else
  begin
   lErrors := lResponse.Split([';']);
   lMsg := '';
   for I := 0 to Length(LErrors) -1  do
      lMsg := lMsg + lErrors[I] + #13#10;
   CancelButton.Enabled := True;
   ChangeButton.Enabled := True;
   DisplayMessage(lMsg, TMsgDlgType.mtError);
  end;



end;

procedure TChangePasswordForm.LoadDFMValues;
begin
  inherited LoadDFMValues;

  PasswordMatchLabel := TLabel.Create('PasswordMatchLabel');
  ExistingPassword := TEdit.Create('ExistingPassword');
  NewPassword := TEdit.Create('NewPassword');
  ConfirmPassword := TEdit.Create('ConfirmPassword');
  ChangeButton := TButton.Create('change-password-save');
  CancelButton := TButton.Create('change-password-cancel');

  PasswordMatchLabel.BeforeLoadDFMValues;
  ExistingPassword.BeforeLoadDFMValues;
  NewPassword.BeforeLoadDFMValues;
  ConfirmPassword.BeforeLoadDFMValues;
  ChangeButton.BeforeLoadDFMValues;
  CancelButton.BeforeLoadDFMValues;
  try
    PasswordMatchLabel.SetParentComponent(Self);
    PasswordMatchLabel.Name := 'PasswordMatchLabel';
    PasswordMatchLabel.Left := 72;
    PasswordMatchLabel.Top := 200;
    PasswordMatchLabel.Width := 112;
    PasswordMatchLabel.Height := 15;
    PasswordMatchLabel.Caption := 'PasswordMatchLabel';
    PasswordMatchLabel.ElementFont := efCSS;
    PasswordMatchLabel.HeightStyle := ssAuto;
    PasswordMatchLabel.HeightPercent := 100.000000000000000000;
    PasswordMatchLabel.Visible := False;
    PasswordMatchLabel.WidthPercent := 100.000000000000000000;
    ExistingPassword.SetParentComponent(Self);
    ExistingPassword.Name := 'ExistingPassword';
    ExistingPassword.Left := 72;
    ExistingPassword.Top := 80;
    ExistingPassword.Width := 121;
    ExistingPassword.Height := 22;
    ExistingPassword.ElementClassName := 'form-control';
    ExistingPassword.ElementFont := efCSS;
    ExistingPassword.ElementPosition := epIgnore;
    ExistingPassword.HeightStyle := ssAuto;
    ExistingPassword.HeightPercent := 100.000000000000000000;
    ExistingPassword.PasswordChar := '*';
    ExistingPassword.WidthStyle := ssAuto;
    ExistingPassword.WidthPercent := 100.000000000000000000;
    NewPassword.SetParentComponent(Self);
    NewPassword.Name := 'NewPassword';
    NewPassword.Left := 72;
    NewPassword.Top := 120;
    NewPassword.Width := 121;
    NewPassword.Height := 22;
    NewPassword.ChildOrder := 1;
    NewPassword.ElementClassName := 'form-control';
    NewPassword.ElementFont := efCSS;
    NewPassword.ElementPosition := epIgnore;
    NewPassword.HeightStyle := ssAuto;
    NewPassword.HeightPercent := 100.000000000000000000;
    NewPassword.PasswordChar := '*';
    NewPassword.WidthStyle := ssAuto;
    NewPassword.WidthPercent := 100.000000000000000000;
    ConfirmPassword.SetParentComponent(Self);
    ConfirmPassword.Name := 'ConfirmPassword';
    ConfirmPassword.Left := 72;
    ConfirmPassword.Top := 160;
    ConfirmPassword.Width := 121;
    ConfirmPassword.Height := 22;
    ConfirmPassword.ChildOrder := 1;
    ConfirmPassword.ElementClassName := 'form-control';
    ConfirmPassword.ElementFont := efCSS;
    ConfirmPassword.ElementPosition := epIgnore;
    ConfirmPassword.HeightStyle := ssAuto;
    ConfirmPassword.HeightPercent := 100.000000000000000000;
    ConfirmPassword.PasswordChar := '*';
    ConfirmPassword.WidthStyle := ssAuto;
    ConfirmPassword.WidthPercent := 100.000000000000000000;
    ChangeButton.SetParentComponent(Self);
    ChangeButton.Name := 'ChangeButton';
    ChangeButton.Left := 88;
    ChangeButton.Top := 240;
    ChangeButton.Width := 96;
    ChangeButton.Height := 25;
    ChangeButton.Caption := 'Change';
    ChangeButton.ChildOrder := 3;
    ChangeButton.ElementClassName := 'btn btn-primary';
    ChangeButton.ElementFont := efCSS;
    ChangeButton.ElementPosition := epIgnore;
    ChangeButton.HeightStyle := ssAuto;
    ChangeButton.HeightPercent := 100.000000000000000000;
    ChangeButton.WidthStyle := ssAuto;
    ChangeButton.WidthPercent := 100.000000000000000000;
    SetEvent(ChangeButton, Self, 'OnClick', 'ChangeButtonClick');
    CancelButton.SetParentComponent(Self);
    CancelButton.Name := 'CancelButton';
    CancelButton.Left := 190;
    CancelButton.Top := 240;
    CancelButton.Width := 96;
    CancelButton.Height := 25;
    CancelButton.Caption := 'Cancel';
    CancelButton.ChildOrder := 3;
    CancelButton.ElementClassName := 'btn btn-primary';
    CancelButton.ElementFont := efCSS;
    CancelButton.ElementPosition := epIgnore;
    CancelButton.HeightStyle := ssAuto;
    CancelButton.HeightPercent := 100.000000000000000000;
    CancelButton.WidthStyle := ssAuto;
    CancelButton.WidthPercent := 100.000000000000000000;
    SetEvent(CancelButton, Self, 'OnClick', 'CancelButtonClick');
  finally
    PasswordMatchLabel.AfterLoadDFMValues;
    ExistingPassword.AfterLoadDFMValues;
    NewPassword.AfterLoadDFMValues;
    ConfirmPassword.AfterLoadDFMValues;
    ChangeButton.AfterLoadDFMValues;
    CancelButton.AfterLoadDFMValues;
  end;
end;

end.
